<template>
  <v-container>
    <div class="selectDocument">
      <Navbar />
      <v-data-table
        v-model="selected"
        :headers="headers"
        :search="search"
        :items="todos"
        :single-select="singleSelect"
        item-key="id"
        disable-sort
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar dark color="#00b2bb">
            <v-row>
              <v-col xs="12">
                <v-toolbar-title>Elija un trámite</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
              </v-col>
              <v-col xs="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }" justify="center">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon small class="mr-2 align-center" color="#00b2bb" v-on="on" @click="goToDocument(item)">mdi-magnify</v-icon>
              </template>
              <span>Ver</span>
            </v-tooltip> </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import api from '@/plugins/api'
import Navbar from '@/components/Navbar'

export default {
  components: { Navbar },
  data () {
    return {
      singleSelect: true,
      todos: [],
      search: '',
      selected: [],
      headers: [
        { text: 'Tramite', value: 'title' },
        { text: '', value: 'actions', sortable: false }
      ]
    }
  },
  mounted () {
    this.getTodos()
  },
  methods: {
    async getTodos () {
      const response = await api.get('posts')
      this.todos = response.data
      /* console.log(response) */
    },
    goToDocument (item) {
      /* console.log('Aca ' + item) */
      this.$router.push(`/NewDocument/Document/${item.id}`)
    }
  }
}
</script>
